import React from "react";

const asset = (name) => `${process.env.PUBLIC_URL || ""}/branding/${name}`;

const BrandSuite = ({ className = "" }) => (
  <div className={`brand-suite grid grid-cols-3 items-center gap-4 ${className}`} aria-label="Edwiser, ExpertLMS, and MySchool branding">
    <div className="flex items-center justify-start min-w-0">
      <img src={asset("edwiser.png")} alt="Edwiser" className="h-12 w-auto max-w-[8rem] object-contain" />
    </div>
    <div className="flex items-center justify-center">
      <span className="text-xl sm:text-2xl font-bold tracking-tight text-indigo-950 whitespace-nowrap">ExpertLMS</span>
    </div>
    <div className="flex items-center justify-end min-w-0">
      <img src={asset("myschool.png")} alt="MySchool" className="h-10 sm:h-11 w-auto max-w-[10rem] object-contain" />
    </div>
  </div>
);

export default BrandSuite;
